import React from 'react'
import { Button, Dropdown } from 'semantic-ui-react'
import useModal from 'hooks/useModal'
import useAxios, { mutate } from 'hooks/useAxios'
import { toast } from 'libs/toast'
import { AllowPermission } from 'shared/components/AllowPermission'
import constants from 'config/constants'

export default function BrandDeleteButton({ brandId }) {
  const { Modal, open, close, isOpen } = useModal()

  return (
    <React.Fragment>
      <Dropdown
        text=""
        icon="far fa-ellipsis-vertical"
        floating
        pointing
        button
        className="bg-white text-black basic top right options"
      >
        <Dropdown.Menu>
          <AllowPermission permission={constants.permissions.manageBrands}>
            <Dropdown.Item
              className="!text-negative"
              text="Delete brand"
              icon="far fa-trash-can"
              onClick={open}
            />
          </AllowPermission>
        </Dropdown.Menu>
      </Dropdown>

      {isOpen && (
        <Modal size="tiny">
          <DeleteBrandModal modal={Modal} close={close} brandId={brandId} />
        </Modal>
      )}
    </React.Fragment>
  )
}

const DeleteBrandModal = ({ modal, close, brandId }) => {
  const { fetch: deleteBrand, loading } = useAxios({
    url: `brand/brands/${brandId}/`,
    method: 'delete',
    skip: true,
  })

  function handleDeleteBrand() {
    deleteBrand()
      .then((res) => {
        if (res.status == 204) {
          toast.success('Brand was successfully deleted.')
          mutate(
            'brand/brands/',
            (state) => {
              return {
                ...state,
                results: state.results.filter((brand) => brand.id !== brandId),
              }
            },
            false
          )
          close()
        }
      })
      .catch((err) => {
        console.error(err)
        toast.error(
          'Uh oh. There was a problem deleting the brand. Please try again or contact Simplesat support.'
        )
      })
  }

  return (
    <React.Fragment>
      <modal.Header>Delete brand</modal.Header>
      <modal.Content>
        <p>
          Deleting this brand will not affect any surveys, only this brand configuration will be
          removed.
        </p>
      </modal.Content>
      <modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={handleDeleteBrand} loading={loading} disabled={loading} negative>
          Delete brand
        </Button>
      </modal.Actions>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/BrandSettings/BrandDeleteButton.js